/**
 * @desc: 继承初始化来源
 *
 * 从 DVA 全局状态中获取上一个页面保存的、
 * 可被当前页面继承的筛选条件值。
 * priority: 10（最低）
 */
import { isEmpty } from '@intelligence/v3/utils/common';
import { extractInheritedValues } from '../utils/filterInherit';

import type { IFilterItemConfig, IFilterValues } from '@intelligence/v3/filterCore/types';
import type { IFilterInitContext, IFilterInitSource } from '../types';

export const inheritSource: IFilterInitSource = {
  name: 'inherit',
  priority: 10,
  shouldClearAfterApply: true,
  /** 从全局继承状态中提取当前页面声明可继承的字段 */
  resolve: async (items: IFilterItemConfig[], context: IFilterInitContext): Promise<IFilterValues> => {
    const { inheritedPageId, inheritedValues } = context || {};

    if (isEmpty(inheritedValues)) {
      return {};
    }

    return extractInheritedValues(items, inheritedPageId, inheritedValues);
  },
};
